import styles from './MainEmailSignupSection.module.scss';
import { AppRoutes } from 'src/types';
import { TermsSection } from 'src/v2/pages/auth/components/TermsSection/TermsSection';
import { EmailSignupForm } from 'src/v2/pages/auth/components/EmailSignupForm';
import { TextWithLinkSection } from 'src/v2/pages/auth/components/TextWithLinkSection';
import React from 'react';
import { Link } from 'react-router-dom';

export const MainEmailSignupSection = () => {
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.signUpHeaderSection}>
          <Link to={AppRoutes.SIGN_UP} className={styles.backToHome}>
            <span className={styles.backToHomeLink}>Back to Sign up</span>
          </Link>
          <h2 className={styles.signUpHeader}>Create your account</h2>
          <span className={styles.signUpSubHeader}>Set up password for </span>
        </div>
        <EmailSignupForm />
        <TextWithLinkSection
          text="Already have an account?"
          linkText="Log in"
          linkRoute={AppRoutes.LOGIN}
        />
        <TermsSection />
        <p className={styles.recaptchaDisclaimer}>
          This site is protected by reCAPTCHA and the Google&nbsp;
          <a href="https://policies.google.com/privacy">Privacy Policy</a>{' '}
          and&nbsp;
          <a href="https://policies.google.com/terms">Terms of Service</a>{' '}
          apply.
        </p>
      </div>
    </div>
  );
};
